<template>
  <NewBsBox
    :bs="{
      'cmp.radio': 'wrapper',
      ...bs,
    }"
    as="label"
  >
    <NewBsBox
      :bs="{ 'cmp.radio': 'radioInput' }"
      :value="value"
      :name="uniqueName"
      :checked="isChecked"
      :disabled="disabled"
      as="input"
      type="radio"
      v-bind="$attrs"
      @change="() => onInput(value)"
    />
    <NewBsBox :bs="{ 'cmp.radio': 'control' }">
      <NewBsBox :bs="{ 'cmp.radio': 'controlChecked' }" />
    </NewBsBox>
    <NewBsBox
      class="radio-label"
      :bs="{ 'cmp.radio': 'label' }"
    >
      <!-- @slot 自定义标签 -->
      <slot :label="label">
        {{ label }}
      </slot>
    </NewBsBox>
  </NewBsBox>
</template>

<script lang="ts">
  import { PropType, defineComponent, computed } from 'vue'
  import { isUndefined } from 'lodash'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import {
    injectOptionsContext,
  } from '@xhs/yam-beer/compose/options/useOptions'
  import initStyle from './style'

  initStyle()

  export default defineComponent({
    name: 'BeerRadio',
    components: {
      NewBsBox,
    },
    props: {
      /**
       * @ignore
       * 覆盖 wrapper inline 的样式
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * Radio set 的组名，对互斥选中场景有用
       */
      name: String,
      /**
       * 标签名称
       */
      label: String,
      /**
       * Radio 选中的 value
       */
      value: {
        type: [String, Number, Boolean, Object],
        default: false,
      },
      /**
       * 受控的值
       */
      modelValue: {},
      /**
       * 是否初始选中，多用于纯样式展示
       */
      checked: {
        type: Boolean,
        default: false,
      },
      /**
       * 是否禁用
       */
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const [context, isFallback] = injectOptionsContext(
        'radiogroup',
        props.value,
        props.modelValue,
      )
      const modelValue = computed(() => {
        if (isFallback) {
          return props.modelValue
        }
        return context.modelValue.value
      })

      const uniqueName = computed(() => {
        if (typeof props.name !== 'undefined') {
          return props.name
        }
        if (isFallback) {
          return props.name
        }
        return context.uniqueName.value
      })

      const isChecked = computed(() => {
        if (isUndefined(modelValue.value)) {
          return props.checked
        }
        if (!isFallback) {
          return context.valueToItem(modelValue.value).id === context.valueToItem(props.value).id
        }
        return modelValue.value === props.value
      })

      const onInput = (value: any) => {
        emit('update:modelValue', value)
        if (!isFallback) {
          context.onChange(context.valueToItem(value))
        }
      }
      return {
        uniqueName,
        isChecked,
        onInput,
      }
    },
  })
</script>
